
        <div class="c-wo-dialogs" [class.dialog-open]="dialog.dialogItems.length">
            <div (click)="onMouseDown($event)" class="c-wo-dialog_item" *ngFor="let dialogItem of dialog.dialogItems; index as di">
                <wo-dialog [attr.data-dialog-id]="di" [dialog]="dialogItem"></wo-dialog>
            </div>
        </div>
        <div *ngIf="dialog.dialogItems.length > 0" class="c-wo-dialogs__bg"></div>
    